module.exports = __webpack_public_path__ + "img/landlord-tenant-agreement.d0741289.svg";